import { render, staticRenderFns } from "./ConfigurationNotPermitted.vue?vue&type=template&id=8033986a"
import script from "./ConfigurationNotPermitted.vue?vue&type=script&lang=js"
export * from "./ConfigurationNotPermitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports